<template>
  <div class="yx-table">
    <el-table
      v-loading="loading"
      :data="data"
      header-cell-class-name="yx-table-head"
      v-bind="$attrs"
      :max-height="maxHeight ? maxHeight : `calc(100vh - 180px)`"
      :stripe="stripe"
      scrollbar-always-on
      ref="table"
      :show-header="showHeader"
      element-loading-background="rgba(0, 0, 0, 0)"
      >
      <slot></slot>
      <template #append>
        <slot name="append"></slot>
      </template>
      <template #empty>
        <slot name="empty">暂无数据</slot>
      </template>
    </el-table>
    <div
      class="flex"
      v-if="haspage"
      :class="{ 'align-center': pageAlign === 'center', 'align-right': pageAlign === 'right' }"
    >
      <yx-pagination v-bind="page" @change="pageChange" :layout="pageLayout" :page-sizes="pageSizes" />
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    data: Array,
    loading: Boolean,
    page: Object,
    haspage: {
      type: Boolean,
      default: true,
    },
    pageAlign: {
      type: String,
      default: 'right',
    },
    pageLayout: String,
    stripe: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    showHeader: {
      type: Boolean,
      default: true,
    },
    maxHeight: String,
  },
  setup(props, { emit }) {
    const table = ref(null);
    const pageChange = (newPage) => {
      emit('page-change', newPage);
    };
    return {
      pageChange,
      table,
      toggleRowSelection(row) {
        table.value.toggleRowSelection(row);
      },
      clearSelection() {
        table.value.clearSelection();
      },
      setCurrentRow() {
        table.value.setCurrentRow();
      },
      getTableRef() {
        return table.value;
      },
    };
  },
});
</script>

<style lang="scss">
.yx-table-head {
  background-color: var(--g9) !important;
  font-weight: 500 !important;
}
.flex {
  display: flex;
}
.align-center {
  justify-content: center;
}
.align-right {
  justify-content: flex-end;
}
.yx-table {
  .el-table__cell {
    height: 50px;
    min-height: 50px;
  }

  // .el-loading-spinner {
  //   background: url('./loading.gif') no-repeat center;
  //   background-size: 200px 200px;
  //   height: 100%;
  //   top: 0;
  // }
  // .el-loading-spinner .circular {/*隐藏 默认的 loading 动画*/
  //   display: none !important;
  // }
  // // .el-loading-spinner .el-loading-text{
  // //     margin-top: 100px !important;
  // // }
  // .el-icon-loading:before{/*隐藏 默认的 loading 动画*/
  //         display: none !important;
  // }
}
</style>
